import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, AlertTriangle } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { PageHero, CTAButton } from "@/components/Shared";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const OPTS = ["Community Safety Days", "Annual Walk", "Fundraising", "Administrative assistance", "Educational events", "Sponsor outreach", "Event setup", "Community outreach"];

export default function Volunteer() {
  const [f, setF] = useState({ name: "", email: "", phone: "", interests: [], notes: "" });
  const [done, setDone] = useState(false);
  const toggle = (o) => setF((s) => ({ ...s, interests: s.interests.includes(o) ? s.interests.filter((x) => x !== o) : [...s.interests, o] }));
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/volunteers", f); setDone(true); } catch (err) { toast.error(formatError(err)); }
  };
  return (
    <div data-testid="volunteer-page">
      <PageHero eyebrow="Volunteer Portal" title="Lend a hand. Save a life." sub="Join the people turning every step into a lifesaving mission." />
      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-12">
        {done ? (
          <div className="text-center rounded-3xl bg-white border border-sky-100 p-10" data-testid="volunteer-success">
            <CheckCircle2 className="w-14 h-14 text-green-500 mx-auto" />
            <p className="font-display uppercase text-3xl text-[#03045E] mt-4">Thank you for signing up!</p>
            <p className="text-slate-600 mt-2">Our team will reach out. Want to track events and register in one place? Create a volunteer account.</p>
            <CTAButton to="/login?mode=register&role=volunteer" className="mt-6" testid="volunteer-create-account">Create volunteer account</CTAButton>
          </div>
        ) : (
          <form onSubmit={submit} className="rounded-3xl bg-white border border-sky-100 p-6 md:p-10 space-y-5">
            <div className="grid sm:grid-cols-3 gap-3">
              <Input required placeholder="Full name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="volunteer-name-input" />
              <Input required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="volunteer-email-input" />
              <Input placeholder="Phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="volunteer-phone-input" />
            </div>
            <div>
              <p className="font-bold text-sm mb-2">I'd like to help with</p>
              <div className="flex flex-wrap gap-2">{OPTS.map((o) => <button type="button" key={o} onClick={() => toggle(o)} data-testid={`volunteer-interest-${o.split(" ")[0].toLowerCase()}`} className={`rounded-full px-4 py-2 text-sm font-semibold border transition-colors duration-200 ${f.interests.includes(o) ? "bg-[#03045E] text-white border-[#03045E]" : "bg-white border-sky-200"}`}>{o}</button>)}</div>
            </div>
            <Textarea placeholder="Anything else? Skills, availability…" value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} data-testid="volunteer-notes-input" />
            <div className="flex gap-3 rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm text-amber-900"><AlertTriangle className="w-5 h-5 shrink-0" />Volunteers do not perform fence installation, engineering, rescue instruction or other skilled work unless properly qualified and authorized.</div>
            <button className="rounded-full bg-[#FF6B35] text-white px-8 py-3 font-bold uppercase" data-testid="volunteer-submit-button">Sign me up</button>
          </form>
        )}
      </section>
    </div>
  );
}
